import React from "react";

export default function TestimonialsContent({ children }) {
  return <div className='testimonials-inner'>{children}</div>;
}
